import { render, staticRenderFns } from "./RegionSelection.vue?vue&type=template&id=594c29cd&scoped=true&"
import script from "./RegionSelection.vue?vue&type=script&lang=js&"
export * from "./RegionSelection.vue?vue&type=script&lang=js&"
import style0 from "./RegionSelection.vue?vue&type=style&index=0&id=594c29cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c29cd",
  null
  
)

export default component.exports